"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("ArrowUp", React.createElement("path", { fill: "currentColor", d: "M13.1,2.3c-0.6-0.6-1.5-0.6-2.1,0l-9.5,9.5c-0.6,0.6-0.6,1.5,0,2.1c0.6,0.6,1.5,0.6,2.1,0L12,5.5l8.4,8.4\n\tc0.6,0.6,1.5,0.6,2.1,0c0.6-0.6,0.6-1.5,0-2.1L13.1,2.3z M13.5,22.8V3.3h-3v19.4H13.5z" }));
//# sourceMappingURL=ArrowUp.js.map